 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Categories":"Categories","CleaningPersonnel":"CleaningPersonnel","CleaningRoomReport~CommandsReports~DocumentsReports~Inventories~Rent~RoomsInUse~SalesReports~histories":"CleaningRoomReport~CommandsReports~DocumentsReports~Inventories~Rent~RoomsInUse~SalesReports~histories","CleaningRoomReport~DocumentCreate~DocumentIndex~Note~RentalCheckout~histories~rentals":"CleaningRoomReport~DocumentCreate~DocumentIndex~Note~RentalCheckout~histories~rentals","CleaningRoomReport":"CleaningRoomReport","histories":"histories","CommandsReports":"CommandsReports","DocumentCreate~People~Rent~RentAdd~RentalCheckout~RoomsInUse":"DocumentCreate~People~Rent~RentAdd~RentalCheckout~RoomsInUse","RoomsInUse":"RoomsInUse","Rent~RentAdd":"Rent~RentAdd","Rent":"Rent","DocumentsReports":"DocumentsReports","Inventories":"Inventories","SalesReports":"SalesReports","DocumentCreate":"DocumentCreate","RentalCheckout":"RentalCheckout","DocumentIndex":"DocumentIndex","Note":"Note","rentals":"rentals","Configurations":"Configurations","Correlatives":"Correlatives","CulqiTokens":"CulqiTokens","Debts":"Debts","People":"People","RentAdd":"RentAdd","Establishments":"Establishments","Items":"Items","Login":"Login","Movements":"Movements","Permissions":"Permissions","Rates":"Rates","ReasonTravelReport":"ReasonTravelReport","Reports":"Reports","Roles":"Roles","RoomTypes":"RoomTypes","Rooms":"Rooms","Salons":"Salons","SearchInvoice":"SearchInvoice","Shifts":"Shifts","Summaries":"Summaries","UnitTypes":"UnitTypes","Users":"Users","Voided":"Voided","cashes":"cashes","openings":"openings","tasks":"tasks"}[chunkId]||chunkId) + "." + {"Categories":"8a6159ef","CleaningPersonnel":"7e9d5516","CleaningRoomReport~CommandsReports~DocumentsReports~Inventories~Rent~RoomsInUse~SalesReports~histories":"165d8983","CleaningRoomReport~DocumentCreate~DocumentIndex~Note~RentalCheckout~histories~rentals":"875b7113","CleaningRoomReport":"6ee4c811","histories":"9b665da5","CommandsReports":"56e6e5a9","DocumentCreate~People~Rent~RentAdd~RentalCheckout~RoomsInUse":"c94fb0c7","RoomsInUse":"9a96540a","Rent~RentAdd":"2206939a","Rent":"66fbd240","DocumentsReports":"eb96f96b","Inventories":"d3069d0e","SalesReports":"562d1b7f","DocumentCreate":"09c6aa77","RentalCheckout":"088bd6ed","DocumentIndex":"91a94bf4","Note":"2ee32843","rentals":"b1e5c022","Configurations":"4dd7f4e1","Correlatives":"97d1237d","CulqiTokens":"05f9bbe1","Debts":"192e702b","People":"69129309","RentAdd":"50bbadff","Establishments":"d7109292","Items":"98fc8cad","Login":"a88c69a0","Movements":"e24eae11","Permissions":"0eb429c5","Rates":"39cc71fe","ReasonTravelReport":"f3473a74","Reports":"51152a68","Roles":"5b487479","RoomTypes":"d9cfb092","Rooms":"11fbfaf6","Salons":"3805c1dc","SearchInvoice":"042de4b1","Shifts":"aa5aecf4","Summaries":"3476ea5d","UnitTypes":"1bde9658","Users":"a46565bc","Voided":"0955bab1","cashes":"f694c55b","chunk-2d0e5e97":"3098d9cd","openings":"2e36abe5","tasks":"d142cc56"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Categories":1,"CleaningPersonnel":1,"Rent~RentAdd":1,"Rent":1,"DocumentIndex":1,"rentals":1,"Configurations":1,"Correlatives":1,"People":1,"Establishments":1,"Login":1,"Permissions":1,"Rates":1,"Roles":1,"RoomTypes":1,"Rooms":1,"Salons":1,"Shifts":1,"UnitTypes":1,"Users":1,"Voided":1,"cashes":1,"tasks":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Categories":"Categories","CleaningPersonnel":"CleaningPersonnel","CleaningRoomReport~CommandsReports~DocumentsReports~Inventories~Rent~RoomsInUse~SalesReports~histories":"CleaningRoomReport~CommandsReports~DocumentsReports~Inventories~Rent~RoomsInUse~SalesReports~histories","CleaningRoomReport~DocumentCreate~DocumentIndex~Note~RentalCheckout~histories~rentals":"CleaningRoomReport~DocumentCreate~DocumentIndex~Note~RentalCheckout~histories~rentals","CleaningRoomReport":"CleaningRoomReport","histories":"histories","CommandsReports":"CommandsReports","DocumentCreate~People~Rent~RentAdd~RentalCheckout~RoomsInUse":"DocumentCreate~People~Rent~RentAdd~RentalCheckout~RoomsInUse","RoomsInUse":"RoomsInUse","Rent~RentAdd":"Rent~RentAdd","Rent":"Rent","DocumentsReports":"DocumentsReports","Inventories":"Inventories","SalesReports":"SalesReports","DocumentCreate":"DocumentCreate","RentalCheckout":"RentalCheckout","DocumentIndex":"DocumentIndex","Note":"Note","rentals":"rentals","Configurations":"Configurations","Correlatives":"Correlatives","CulqiTokens":"CulqiTokens","Debts":"Debts","People":"People","RentAdd":"RentAdd","Establishments":"Establishments","Items":"Items","Login":"Login","Movements":"Movements","Permissions":"Permissions","Rates":"Rates","ReasonTravelReport":"ReasonTravelReport","Reports":"Reports","Roles":"Roles","RoomTypes":"RoomTypes","Rooms":"Rooms","Salons":"Salons","SearchInvoice":"SearchInvoice","Shifts":"Shifts","Summaries":"Summaries","UnitTypes":"UnitTypes","Users":"Users","Voided":"Voided","cashes":"cashes","openings":"openings","tasks":"tasks"}[chunkId]||chunkId) + "." + {"Categories":"3ab7a86c","CleaningPersonnel":"3ab7a86c","CleaningRoomReport~CommandsReports~DocumentsReports~Inventories~Rent~RoomsInUse~SalesReports~histories":"31d6cfe0","CleaningRoomReport~DocumentCreate~DocumentIndex~Note~RentalCheckout~histories~rentals":"31d6cfe0","CleaningRoomReport":"31d6cfe0","histories":"31d6cfe0","CommandsReports":"31d6cfe0","DocumentCreate~People~Rent~RentAdd~RentalCheckout~RoomsInUse":"31d6cfe0","RoomsInUse":"31d6cfe0","Rent~RentAdd":"7df717b5","Rent":"98cebd45","DocumentsReports":"31d6cfe0","Inventories":"31d6cfe0","SalesReports":"31d6cfe0","DocumentCreate":"31d6cfe0","RentalCheckout":"31d6cfe0","DocumentIndex":"98cebd45","Note":"31d6cfe0","rentals":"0814a253","Configurations":"3ab7a86c","Correlatives":"3ab7a86c","CulqiTokens":"31d6cfe0","Debts":"31d6cfe0","People":"3ab7a86c","RentAdd":"31d6cfe0","Establishments":"3ab7a86c","Items":"31d6cfe0","Login":"d7744c16","Movements":"31d6cfe0","Permissions":"3ab7a86c","Rates":"3ab7a86c","ReasonTravelReport":"31d6cfe0","Reports":"31d6cfe0","Roles":"3ab7a86c","RoomTypes":"3ab7a86c","Rooms":"3ab7a86c","Salons":"3ab7a86c","SearchInvoice":"31d6cfe0","Shifts":"3ab7a86c","Summaries":"31d6cfe0","UnitTypes":"3ab7a86c","Users":"0814a253","Voided":"98cebd45","cashes":"3ab7a86c","chunk-2d0e5e97":"31d6cfe0","openings":"31d6cfe0","tasks":"3ab7a86c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
